module.exports = __webpack_public_path__ + "img/story.603ccd5b.png";